import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS, device, FONTS } from '../../../../constants';

interface AboutUsTeamItemProps {
  name: string;
}

const AboutUsTeamItem = ({ name }: AboutUsTeamItemProps) => {
  return (
    <AboutUsTeamItemWrapper>
      <Text text={name} size={24} lineHeight={36} fontFamily={FONTS.TITLE} />
    </AboutUsTeamItemWrapper>
  );
};
const AboutUsTeamItemWrapper = styled.div`
  padding: 10px;
  box-sizing: border-box;
  flex: 0 0 45%;
  border-bottom: 1px solid ${COLORS.RED_PRESSED};
  h4 {
    font-weight: 600;
  }
  @media screen and ${device.md} {
    h4 {
      font-size: 16px;
      line-height: 1.5;
    }
  }
  @media screen and ${device.sm} {
    h4 {
      font-size: 13px;
    }
    padding: 5px;
  }
  @media screen and ${device.xs} {
    h4 {
      font-weight: 500;
    }
  }
`;
export { AboutUsTeamItem };
